/**
 * Click-to-load YouTube facade for the video-outcomes block.
 *
 * The block ships a poster button rather than an <iframe>, so no third-party
 * request happens on first render. This module swaps the poster for the real
 * embed on click, with autoplay=1 so the click that loaded it also starts it.
 *
 * The block falls back to a raw iframe when it has no poster, so this module
 * is an enhancement and never a dependency: if the bundle dies, a poster-less
 * block still plays and a poster-ful one still shows its poster.
 */

const SELECTOR = '[data-awdd-video]';

function mount(frame) {
	const button = frame.querySelector('[data-awdd-video-play]');
	const id = frame.dataset.videoId;
	if (!button || !id) return;

	button.addEventListener('click', () => {
		const iframe = document.createElement('iframe');
		iframe.src =
			'https://www.youtube-nocookie.com/embed/' +
			encodeURIComponent(id) +
			'?autoplay=1&rel=0';
		// A screen-reader user tabbing to the loaded player should hear what it
		// contains, not the name of the button they just pressed — the button's
		// aria-label ("Play video") is an action, not a description. Match the
		// template's no-poster iframe, which titles itself "Training video".
		iframe.title = 'Training video';
		iframe.allow =
			'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
		iframe.allowFullscreen = true;
		iframe.className = 'absolute inset-0 h-full w-full';

		button.remove();
		frame.appendChild(iframe);
		// Move focus into the player so a keyboard user is not dropped at <body>.
		iframe.focus({ preventScroll: true });
	});
}

export default function initVideoFacade() {
	document.querySelectorAll(SELECTOR).forEach(mount);
}
